import React from 'react';
import { useUser, SignIn } from '@clerk/clerk-react';

export default function RequireAdmin({ children }) {
  const { isLoaded, isSignedIn, user } = useUser();
  if (!isLoaded) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <p>Verifying session…</p>
      </div>
    );
  }
  if (!isSignedIn) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 20px' }}>
        <SignIn routing="hash" />
      </div>
    );
  }
  if (user.publicMetadata?.role !== 'admin') {
    return (
      <div style={{ padding: 40, textAlign: 'center', maxWidth: 600, margin: '40px auto' }}>
        <h2>Not an admin</h2>
        <p>Your account is signed in but doesn't have admin access. Ask the site owner to promote you, then sign out and back in.</p>
      </div>
    );
  }
  return children;
}
